import React, { useEffect } from 'react';

import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import Header from '@components/Base/Header';
import ExamList from '@components/Exams';
import { useAppDispatch, useAppSelector } from '@utils/hooks';
import { RootState } from '@utils/store';

import messages from './messages';
import { getExamsAction } from './slice';
import { Exam } from './types';

export type AppliedFilters = {
  selectedStatus?: { label: string; value: string }[];
  selectedUser?: { label: string; value: string }[];
  selectedWorkflow?: { label: string; value: string }[];
};

const Exams = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { data: exams, isLoading } = useAppSelector((state: RootState) => state.examsList);

  const handleWorkflowClick = (exam: Exam) => {
    const exam_id = exam.id;
    navigate(`${exam_id}/workflows`);
  };

  useEffect(() => {
    dispatch(getExamsAction());
  }, []);

  return (
    <>
      <Header details={{ label: <FormattedMessage {...messages.exams} /> }} />
      <ExamList exams={exams} isLoading={isLoading} handleWorkflowClick={handleWorkflowClick} />
    </>
  );
};

export default Exams;
